import React from "react";
import { cn } from "../lib/utils";

export function scoreColor(score) {
  if (score >= 70) return "emerald";
  if (score >= 40) return "amber";
  return "red";
}

export function ScoreBadge({ score, size = "sm", testId }) {
  const c = scoreColor(score);
  const map = {
    emerald: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
    amber: "bg-amber-500/15 text-amber-500 border-amber-500/30",
    red: "bg-red-500/15 text-red-500 border-red-500/30",
  };
  const sizes = { sm: "text-sm px-2.5 py-1", lg: "text-2xl px-4 py-1.5" };
  return (
    <span
      data-testid={testId}
      className={cn("font-mono font-bold rounded-full border inline-flex items-center", map[c], sizes[size])}
    >
      {score}
    </span>
  );
}

const riskMap = {
  Low: { color: "text-emerald-500", bg: "bg-emerald-500", border: "border-emerald-500/30 bg-emerald-500/10", fill: 33 },
  Medium: { color: "text-amber-500", bg: "bg-amber-500", border: "border-amber-500/30 bg-amber-500/10", fill: 66 },
  High: { color: "text-red-500", bg: "bg-red-500", border: "border-red-500/30 bg-red-500/10", fill: 100 },
};

export function RiskBadge({ level, testId }) {
  const r = riskMap[level] || riskMap.Medium;
  return (
    <span
      data-testid={testId}
      className={cn("text-xs font-semibold px-2 py-0.5 rounded-md border inline-flex items-center gap-1", r.border, r.color)}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", r.bg)} />
      {level}
    </span>
  );
}

export function RiskMeter({ level, atrPct }) {
  const r = riskMap[level] || riskMap.Medium;
  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Risk Meter</span>
        <span className={cn("text-sm font-semibold", r.color)}>{level}</span>
      </div>
      <div className="h-2.5 w-full bg-secondary rounded-full overflow-hidden flex">
        <div className="h-full transition-all duration-500 rounded-full"
          style={{ width: `${r.fill}%`, background: "linear-gradient(90deg,#10B981,#F59E0B,#EF4444)" }} />
      </div>
      {atrPct != null && (
        <p className="text-xs text-muted-foreground mt-1.5 font-mono">Volatility (ATR): {atrPct}% of price</p>
      )}
    </div>
  );
}

export function SourceBadge({ source }) {
  const live = source === "live";
  return (
    <span className={cn(
      "text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-full border inline-flex items-center gap-1",
      live ? "text-emerald-500 border-emerald-500/30 bg-emerald-500/10"
           : "text-amber-500 border-amber-500/30 bg-amber-500/10"
    )}>
      <span className={cn("h-1.5 w-1.5 rounded-full", live ? "bg-emerald-500" : "bg-amber-500")} />
      {live ? "Live data" : "Simulated (fallback)"}
    </span>
  );
}
